import { render, staticRenderFns } from "./ClicIcon.vue?vue&type=template&id=0e573320&"
import script from "./ClicIcon.vue?vue&type=script&lang=js&"
export * from "./ClicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports